import { render, staticRenderFns } from "./devices.vue?vue&type=template&id=241f048a&scoped=true"
import script from "./devices.vue?vue&type=script&lang=js"
export * from "./devices.vue?vue&type=script&lang=js"
import style0 from "./devices.vue?vue&type=style&index=0&id=241f048a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241f048a",
  null
  
)

export default component.exports